import {
  NPVR_DELETE_EVENT_INIT,
  NPVR_DELETE_EVENT_SUCCESS,
  NPVR_DELETE_EVENT_ERROR,
  NPVR_DELETE_EVENT_CLEAR,
} from '../../actions/recording/constants';

const initialState = {
  loading: false,
  data: null,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NPVR_DELETE_EVENT_INIT:
      return { ...state, loading: true, error: false, data: null };
    case NPVR_DELETE_EVENT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: false };
    case NPVR_DELETE_EVENT_ERROR:
      return { ...state, loading: false, data: action.error, error: true };
    case NPVR_DELETE_EVENT_CLEAR:
      return { ...state, loading: false, data: null, error: false };
    default:
      return state;
  }
};
